<template lang="pug">
div.theheader#header
  vm-navbar(class="nabar" type="flat")
    vm-navbar-item.c-logos(index="0")
      img.logo(src="@/assets/logo.png" @click="$router.push('/')")
      .c-l-container.c-logos(v-if="$auth.user().company_logo")
        img.logo(:src="$auth.user().company_logo")
    router-link(to='/')
    vm-spacer
    vm-navbar-item(index="1")
      search-projects(@click="openModalSearchProjects")
    vm-spacer
    vm-navbar-item(index="2")
      vm-button(ref="button" type="default" icon="bell-outline" size="small" :indicator="!emptyNotifications" color="primary" @click="setNotificationsVisible")
    vm-navbar-item(index="3")
      vm-dropdown
        vm-avatar(:src="$auth.user().avatar_photo || 'https://avatars2.githubusercontent.com/u/44278536?s=200&v=4'")

        vm-dropdown-menu
          vm-dropdown-item
            .user(@click="() => this.$router.push('/profile')")
              .col1
                vm-avatar(:src="$auth.user().avatar_photo || 'https://avatars2.githubusercontent.com/u/44278536?s=200&v=4'")
              .col2
                .name {{ $auth.user().name }}
                .email {{ $auth.user().email }}
          vm-dropdown-item(@click="setModalFeedbackVisible(true)" divider) Enviar Comentarios
          vm-dropdown-item(@click="logout" divider) {{ $t('login.logout') }}
</template>

<script>
import SearchProjects from '@/components/aditionals/SearchProjects.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TheHeader',
  components: {
    SearchProjects
  },
  methods: {
    ...mapActions([
      'setModalFeedbackVisible',
      'setNotificationsVisible',
      'setModalSearchProjectsVisible'
    ]),
    logout () {
      this.$router.push('/login')
      this.$auth.logout({
        makeRequest: true,
        redirect: { name: 'login' }
      })
    },
    openModalSearchProjects () {
      this.setModalSearchProjectsVisible(true)
    }
  },
  computed: {
    ...mapGetters([
      'notifications'
    ]),
    emptyNotifications () {
      return this.notifications.length === 0
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.c-logos {
  display: flex;
  align-items: center;
  img.logo {
    height: 20px;
  }
}
.c-logos > .logo:first-child {
  cursor: pointer;
}
.theheader {
  position: fixed;
  width: calc(100% - 65px);
  margin-left: 65px;
  background: white;
  z-index: 10000;
  border-top-left-radius: 15px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  .nabar {
    padding: .4rem 1rem;
    .logo-header {
      margin-left: 25px;
    }
    .vm-navbar--item {
      padding: 0 10px;
      display: flex;
    }
  }
}
.heading {
  min-width: 180px;
  padding: 2px 12px;
  h4 {
    padding-top: 3px;
  }
}
.nonotifications {
  text-align: center;
}
.con-vm-avatar {
  border-radius: 5px !important;
  top: 4px;
  .con-img {
    border-radius: 5px !important;
  }
}
.user{
  display: flex;
  flex-direction: row;
  line-height: normal;
  align-items: center;
  .col1 {
    margin-right: 5px;
  }
  .name {
    color: rgb(39, 44, 55);
  }
  .email {
    font-size: 11px;
    color: rgb(142, 155, 178);
  }
}
.c-l-container {
  margin-left: 15px;
  padding-left: 15px;
  border-left: 1px solid rgb(197, 197, 197);
}
@media only screen and (min-width: 1930px) {
  .theheader {
    margin-left: 3.5vw !important;
  }
  .c-logos {
    img.logo {
      height: 2vw;
    }
  }
}
</style>
